
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'normalize.css/normalize.css' // 重置样式
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/zh-CN' // 中文 i18n
import './styles/index.scss' // 全局样式
import './assets/js/flexible.js'// 手淘适配
import './assets/icon/iconfont.css' // 图标样式
import preview from 'vue-photo-preview' // 图片放大
import 'vue-photo-preview/dist/skin.css' // 图片放大样式
import './permission' // 权限文件
import plugins from './utils/plugins' // 全局指令
import mixin from './utils/mixin' // 全局事件

/** 
 * vue切换路由时报错Uncaught (in promise) NavigationDuplicated {_name: "NavigationDuplicated"} 如下方法统一修改
 * this.$router.push('/home',()=>{}) 方法二
 * npm i vue-router@3.0 -S 方法三
*/
import Router from 'vue-router'
 const originalPush = Router.prototype.push
 Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

import vuescroll from 'vuescroll' // 滚动条样式插件
import 'vuescroll/dist/vuescroll.css'

import * as filters from './filters' // 全局过滤器

import permission from '@/directive/permission/index.js' // 权限判断指令

// 表格自适应指令
import tableHeight from '@/directive/tableheight/index.js'
Vue.use(tableHeight)

// Tip组件
import Tooltip from 'vue-directive-tooltip'
Vue.use(Tooltip)

import Storage from 'vue-ls' // 本地储存 

Vue.use(Storage, {
  storage: 'session', // 存储名称: session, local, memory
})

Vue.config.productionTip = false

Vue.use(ElementUI, { locale, size: 'small'})
Vue.use(preview)

Vue.use(mixin)

Vue.use(plugins)

Vue.use(vuescroll)

const R = require('ramda')
Vue.prototype.R = R

const M = require('moment')
Vue.prototype.M = M

// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.directive('permission', permission)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js